<div class="overlay" *ngIf="isloading | async">
  <p-progressSpinner
    class="spinner"
    [style]="{ width: '80px', height: '80px' }"
    strokeWidth="1"
  ></p-progressSpinner>
  <!-- <h4 class="text-loading">Loading ...</h4> -->
</div>
